import { FC } from 'react';
import { Card } from 'react-daisyui';
import { useAuthContext } from '@/context/AuthContext';

const CompanyDashboardPage: FC = () => {
  const { session } = useAuthContext();

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Company Admin Dashboard</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card className="bg-base-100 shadow-xl">
          <Card.Body>
            <Card.Title>Welcome</Card.Title>
            <p>Logged in as: {session?.user?.email}</p>
          </Card.Body>
        </Card>

        <Card className="bg-base-100 shadow-xl">
          <Card.Body>
            <Card.Title>Statistics</Card.Title>
            <p>Coming soon...</p>
          </Card.Body>
        </Card>

        <Card className="bg-base-100 shadow-xl">
          <Card.Body>
            <Card.Title>Recent Activity</Card.Title>
            <p>Coming soon...</p>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default CompanyDashboardPage;

